module.exports = "js/webpack/485860c000764fd82149fc94aa6673cd.png";